module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.url) ? _c('a', {
    staticClass: "icon",
    attrs: {
      "target": "_blank",
      "href": _vm.url
    }
  }, [_c('div', {
    staticClass: "icon__data"
  }, [_c('div', {
    staticClass: "icon__img",
    class: _vm.iconType
  })])]) : _c('div', {
    staticClass: "icon",
    attrs: {
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "icon__data"
  }, [_c('div', {
    staticClass: "icon__img",
    class: _vm.iconType
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45dfa987","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/progress/components/result/components/progress/components/icons/Icons.vue
// module id = d20b50bed1a5acf38086
// module chunks = 11